<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('team')"
          :text="$t('team-info-text')"
          :showBtn="get_is_admin"
          :btnText="$t('Add team mate')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            @click="goToProfile(item.id)"
            v-for="(item, index) in get_users.items" :key="`item-${index}`">
            <div class="table-cell small">
              <div class="news-header flex">
                <div class="post-image" :class="item.is_active == true ? 'active' : ''">
                  <div class="status-indicator"></div>
                  <span class="initials">
                    {{ `${item.first_name.charAt(0)}${item.last_name.charAt(0)}` }}
                  </span>
                  <div class="image-holder">
                    <img :src="item.image" v-if="item.image !== null"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.first_name} ${item.last_name}` }}
              </span>
                <span class="additional-info">{{ item.function }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Add team mate') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12 m-b-20" v-if="get_user.is_super_admin">
            <InputSelect
              :multiSelect=true
              :label="$t('Accessible accounts')"
              :preselected="form.accessible_subaccounts"
              @change="selectSubaccounts"
              :rules="{required: true}"
              :options="subacountsList"/>
          </div>
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('User role')"
              v-model="userRole"
              :options="getUserRoleOptions"/>
          </div>
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('language')"
              :countryFlag="true"
              v-model="form.language"
              :options="[{value: 'en', text: 'English', country: 'GB'}, {value: 'dk', text: 'Danish', country: 'DK'}]"/>
          </div>
          <InputText
            class="col-xs-12 m-b-20"
            label="E-mail"
            v-model="form.email"
            :rules="{required: true, email: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('name')"
            v-model="form.first_name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-6 m-b-20"
            :label="$t('Surname')"
            v-model="form.last_name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('Title')"
            v-model="form.function" />
          <PhoneSelect class="col-xs-12" key="userPhone" v-model="form.phone" />
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import Toggle from '@/components/elements/inputs/toggle.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import formValidator from '@/mixins/formValidator';

import InfoTextBox from '@/components/global/infoTextBox';

export default {
  name: 'Team',
  components: { Popup, InputText, InfoTextBox, Toggle, InputSelect, PhoneSelect },
  mixins: [formValidator],
  data() {
    return {
      openPopup: false,
      userRole: '0',
      form: {
        is_super_admin: '0',
        is_admin: '0',
        is_active: '1',
        language: 'en',
        email: '',
        first_name: '',
        last_name: '',
        function: '',
        return_waybill_action_type: '1',
        label_printer_id: '0',
        label_format: '1',
        goods_type_id: '1',
        package_id: '0',
        weight_type: 'kg',
        dimension_type: 'cm',
        should_show_freight_prices: true,
        phone: {
          number: '',
          country: '',
        },
        accessible_subaccounts: [],
      },
    };
  },
  computed: {
    ...mapGetters([
      'get_is_admin',
      'get_users',
      'get_user_by_id',
      'get_subaccounts',
      'get_user'
    ]),
    isPopupSubmitDisabled() {
      if(this.get_user.is_super_admin && this.form.accessible_subaccounts.length == 0) return true;
      const formWithValidators = [
        {
          formFeild:'email',
          value: this.form.email,
          validators:{required: true, email: true}
        },
        {
          formFeild:'first_name',
          value: this.form.first_name,
          validators:{required: true}
        },
        {
          formFeild:'last_name',
          value: this.form.last_name,
          validators:{required: true}
        },
      ]
      return this.validateInput(formWithValidators);
    },
    subacountsList() {
      return  this.get_subaccounts.map((acc) => ({text: acc.name, value: String(acc.id)}));
    },
    getUserRoleOptions() {
      let options = []

      if (this.get_user.is_system_user) {
        options.push({value: '2', 'text': 'Super Admin'})
      }

      options.push({value: '1', text: 'Administrator'}, {value: '0', text: 'Regular user'});

      return options;
    }
  },
  created() {
    this.$store.dispatch('GET_USERS');
  },
  methods: {
    selectSubaccounts(val) {
      this.form.accessible_subaccounts = val;
    },
    clearLocalFormData() {
      this.form = {
        is_super_admin: '0',
        is_admin: '0',
        is_active: '1',
        language: 'en',
        email: '',
        first_name: '',
        last_name: '',
        function: '',
        return_waybill_action_type: '1',
        label_printer_id: '0',
        label_format: '1',
        goods_type_id: '1',
        // package_id: '', stavi null
        weight_type: 'kg',
        dimension_type: 'cm',
        should_show_freight_prices: true,
        phone: {
          number: '',
          country: '',
        },
        accessible_subaccounts: [],
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.clearLocalFormData();
    },
    submitForm() {
      this.$store.dispatch('SET_USER', {
        form: {
          ...this.form,
          phone: this.form.phone.number,
          is_admin: ['1', '2'].includes(this.userRole),
          is_super_admin: ['2'].includes(this.userRole),
        },
      }).then(() => {
        this.$store.dispatch('GET_USERS');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    goToProfile(id) {
      this.$router.push({ path: `/user/wall/${id}` });
    },
    openNewPopup() {
      this.togglePopup();
    },
  },
};
</script>
